import { MODULE_ROUTE, ROOT_ROUTE } from '@core/models/routes.model';

/** Pages that are part of signing in: returning to one after login would loop or show the wrong page. */
const SIGN_IN_ROUTES: string[] = [MODULE_ROUTE.AUTH, '/join'];

function hasControlCharacter(url: string): boolean {
    return [...url].some(character => (character.codePointAt(0) ?? 0) < 32);
}

/**
 * The url to return to after login, when it is a page inside the app: an absolute path that is
 * not protocol relative (`//host`, `/\host`), not the home page and not a sign-in page.
 * Anything else is ignored, so the user lands on their root folder as usual.
 */
export function safeReturnUrl(url: unknown): string | undefined {
    if (typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//') || url.includes('\\') || hasControlCharacter(url)) {
        return undefined;
    }

    const path = url.split(/[?#]/)[0];
    if (path === String(ROOT_ROUTE.HOME) || SIGN_IN_ROUTES.some(route => path === route || path.startsWith(route + '/'))) {
        return undefined;
    }

    return url;
}
